/* External Imports */
import { Link } from '@chakra-ui/next-js';
import { Box, Button, Flex, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';

/* Services */

/**
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */

const GetInvolved = ({ sectionContent }) => {
  // console.log(sectionContent, 'GetInvolved');
  const imageContent = sectionContent.find(
    item => item._modelApiKey === 'single_image'
  );
  const titleContent = sectionContent.find(
    item => item.fieldId === 'title-bold-mix'
  );
  const bodyContent = sectionContent.find(
    item =>
      item._modelApiKey === 'structured_text' &&
      item.fieldId !== 'title-bold-mix'
  );
  const buttonContent = sectionContent.find(
    item => item._modelApiKey === 'simple_button'
  );
  const kolamContent = sectionContent.find(
    item => item._modelApiKey === 'top_kolam'
  );

  // Extract the words from the title content
  const words = titleContent
    ? titleContent.body.value.document.children[0].children.map(
        span => span.value
      )
    : [];

  // Ensure there are at least two words
  const firstWord = words.length > 0 ? words[0] : '';
  const secondWord = words.length > 1 ? words[1] : '';

  return (
    <>
      <Box
        width="100%"
        paddingTop={{
          md: '100px',
          base: kolamContent ? '0rem' : '4rem',
          lg: '7rem',
          '2xl': '12rem',
        }}
        px={{ base: '0', sm: '1rem' }}
        paddingBottom={{
          md: '100px',
          base: kolamContent ? '9rem' : '50px',

          lg: kolamContent ? '14rem' : '9rem',
        }}
        bgImage={`url(${config.imgPath}/d/46272/1724507120-rectangle-601.png)`}
        clipPath={{
          base: kolamContent ? 'polygon(0 0, 100% 0%, 100% 100%, 0 97%)' : '',
          lg: kolamContent
            ? 'polygon(0 0, 100% 0%, 100% 100%, 0 97%)'
            : 'polygon(0 0, 100% 9%, 100% 100%, 0% 100%)',
        }}
      >
        <Box width="100%" maxW={1100} mx="auto">
          {/* kolam */}
          {kolamContent && (
            <Box
              display={{ base: 'flex' }}
              width={{ base: '200px', md: '250px', lg: '350px' }}
              justifyContent={'center'}
              marginY={{ base: '4rem' }}
              mx="auto"
              maxW="500px"
            >
              <LazyLoadImageComponent
                src={`${config.imgPath}/d/46272/1721626573-threekolam.png`}
                alt="Workshop Kolam"
              />
            </Box>
          )}

          {/* flex */}
          <Box
            display={{ base: 'flex' }}
            alignItems="center"
            justifyContent="center"
            flexDirection={{ base: 'column', lg: 'row' }}
            // marginLeft={{ xl: '181px' }}
            // marginRight={{ xl: '182px' }}
          >
            {/* box1 */}
            <Box
              height={{ base: '100%', md: '100%' }}
              width={{ base: '100%', sm: '321px' }}
              filter="grayscale(100%)"
            >
              {imageContent && (
                <LazyLoadImageComponent
                  src={imageContent.image.url}
                  alt={imageContent.image.alt || 'no image'}
                  // width={420}
                  width={'100%'}
                  height={{ base: '203px', md: '100%', lg: '100%' }}
                  objectFit="cover" // To maintain aspect ratio and cover the entire area
                />
              )}
            </Box>

            {/* box 2 */}
            <Flex
              mt={{ base: '40px', md: '0' }}
              height="100%"
              textAlign="center"
              maxW={{ base: 625, md: 625, xl: '720px' }}
              ml={{ base: '0', md: '5%' }}
              flexDirection="column"
              gap={{ xl: '2rem', '2xl': '1.5rem' }}
              justifyContent="space-between"
              px={{ base: '1rem', sm: '0' }}
            >
              <Box
                display="flex"
                textAlign="center"
                gap={2}
                color="#010509"
                alignItems="center"
                justifyContent={{ base: 'center', lg: 'flex-start' }}
                fontSize={{ base: '1.5rem', md: '2.5rem' }} // 24px in rem
                mb={{ md: '1rem', xl: '0' }}
              >
                <Text
                  fontSize={{ md: '2.5rem', base: '1.5rem' }}
                  textAlign={'center'}
                  fontFamily={'var(--FedraSerifDisplay-Regular)'}
                >
                  {firstWord}
                </Text>
                <Text
                  fontFamily="var(--FedraSerifDisplay-light)"
                  fontWeight="bold"
                  fontSize={{ md: '2.5rem', base: '1.5rem' }}
                >
                  {secondWord}
                </Text>
              </Box>
              {bodyContent && (
                <Text
                  fontSize={{ base: '1rem', md: '22px' }} // 16px in rem
                  fontFamily="var(--FedraSansStd-book)"
                  marginBottom={{ md: '1rem', xl: '0' }}
                  lineHeight="160%"
                  color="#0E1216"
                  textAlign={{ base: 'center', lg: 'start' }}
                  letterSpacing="2%"
                >
                  {
                    bodyContent.body.value.document.children[0].children[0]
                      .value
                  }
                </Text>
              )}

              {buttonContent && (
                <Button
                  as={Link}
                  href={buttonContent?.linkUrl}
                  mb={{ md: '20px', lg: '0' }}
                  mx={{ base: '1rem', lg: '0' }}
                  width={{ lg: '196px' }}
                  height={{ base: '50px' }}
                  // paddingBottom={10}
                  display={{ base: 'flex' }}
                  alignItems="center"
                  justifyContent="center"
                  paddingY={{ base: '.75rem', lg: '0' }}
                  paddingX={{ base: '2rem', lg: '0' }}
                  border="none"
                  borderRadius="none"
                  marginTop={{ base: '10px', xl: '0' }}
                  bg={
                    buttonContent.buttonText === 'GET IN TOUCH'
                      ? '#F18128'
                      : buttonContent.buttonStyle === 'Orange'
                      ? '#EDA807'
                      : 'default'
                  }
                  _hover={{
                    bg: '#F2C251',
                    textDecor: 'none',
                  }}
                  color="#010509"
                  fontWeight="medium"
                  fontSize={{ base: '1rem' }}
                  fontFamily="var(--FedraSansStd-medium)"
                  prefetch
                >
                  {buttonContent.buttonText}
                </Button>
              )}
            </Flex>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default GetInvolved;
